import http from "@/utils/http";
import { Message } from "@arco-design/web-react";
/**
 * 获取账号列表
 * **/

export const interfaceRequest = async (url, type, params = null, header = null) => {
  const method = {
    1: "get",
    2: "post",
    3: "delete",
    4: "put",
  };
  try {
    const res = await http[method[type]](`/api/v1/crm${url}`, type == 1 ? { params } : params, header);
    if (res) {
      return res;
    }
  } catch (err) {
    if (err != "验证码错误") {
      Message.error(err);
    }
    return err;
  }
};
export async function getAccountPage(params): Promise<any> {
  try {
    const res = await http.get("/api/v1/crm/user", { params });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    return err;
  }
}

export async function getUserInfo(): Promise<any> {
  try {
    const res = await http.get("/api/v1/crm/user/info");
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
    return err;
  }
}
// 一键登录
export async function getMemberLogin(params): Promise<any> {
  try {
    const res = await http.get("/api/v1/crm/member/one/login", {
      params,
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
    return err;
  }
}

// 套餐详情
export const packageDetail = (params: any) => {
  return http.get("/api/v1/crm/member/detail", { params });
};

// 开通产品
export const activateProdut = (data: { id: number; module: string }) => {
  return http.put("/api/v1/admin/team/product", data);
};

// 修改密码
export const modifyPassword = (data: any) => {
  return http.post("/api/v1/crm/member/password", data);
};
